import { checkIsFirstVisitToday, checkIsWithinTime, clearExpiredRecord, recordTime, recordTodayVisit } from '@/app/eflayout/Header/time';
import { signupCookie } from '@/utils/cookies/signupCookie';
import gtm from '@/utils/gtm';
import classNames from 'classnames';
import getDevice from 'lowcode/common/getDevice';
import { getEfDeviceId } from 'lowcode/utils/getBrowserIdFromCanvas';
import { getIsLogin } from 'lowcode/utils/getIsLogin';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import HeaderIconUser from '../IconUser';
import HeaderUserTipsPc from './HeaderUserTipsWin/HeaderUserTipsPc';
import './HeaderUserTipsWin/index.scss';

// 没有登录
export default function HeaderUserNone() {
    const router = useRouter();
    const [isOpen1, setIsOpen1] = useState(false); //用于悬浮
    const [isOpen2, setIsOpen2] = useState(false); //用于点击|24小时
    const { query, pathname, locale = 'us' } = router;

    const [isLogin, setIsLogin] = useState(false);
    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsLogin(isLogin2);
    }, []);

    const isSpecifySite = useMemo(() => {
        if (locale === 'us') {
            return ['/delta-pro-3-portable-power-station', '/power-preparedness'].includes(pathname);
        }
        if (locale === 'de') {
            return ['/vanlife-roadtrips', '/recreational-activities'].includes(pathname);
        }
        return false;
    }, [pathname, locale]);

    // 端点击个人中心
    // 2026-06-11 https://ecoflow.feishu.cn/docx/SS9bdePWmoipqGxesvecZOhjn3e
    const enterUserHandle = () => {
        signupCookie?.({ entry_name: 'top navigation icon', skip: true });
        if (!isLogin) {
            router.push(`/${locale}/login?redirect=${encodeURIComponent(location.href)}`);
            return;
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'signup_start',
            entry_type: 'fixed entry',
            entry_name: 'top navigation icon',
            entry_position: 'none',
            source_channel: 'Website',
            __btn_id1: `ef-header-user`,
            __btn_id2: `user`,
            __btn_type: 'common',
        });
        // 跳转链接添加inviCode
        const { inviteCode } = query;
        const concatInviCode = inviteCode && pathname === '/referral-rewards';
        router.push(`/${locale}/login${concatInviCode ? `?inviteCode=${inviteCode}&redirect=${encodeURIComponent(location.href)}` : ''}`);
    };
    // 打开
    const openCallback = () => {
        setIsOpen1(true);
    };
    // 关闭
    const closeCallback1 = () => {
        setIsOpen1(false);
    };
    // 关闭
    const closeCallback2 = () => {
        setIsOpen2(false);
        setIsOpen1(false);
        recordTime(locale); //24小时内出现过
    };
    const compCls = classNames('HeaderV2-r-item HeaderV2-r-item-UserNone', {
        [`HeaderV2-r-item-open1`]: isOpen1,
        [`HeaderV2-r-item-open2`]: isOpen2,
    });
    // 10s后关闭
    const closeWinFor10SecondHandle = () => {
        setTimeout(() => {
            setIsOpen2(false);
        }, 10 * 1000);
    };
    const initTipsWinFor24 = () => {
        // 仅在首页展示
        if (pathname !== `/`) {
            return;
        }
        if (['eu', 'uk', 'de', 'fr'].includes(locale)) {
            return;
        }
        // 不在24小时内或者不符合弹窗规则，则跳过
        const isFlag = checkIsWithinTime(locale);

        if (isFlag) {
            return;
        }

        // 清除超过24h的弹窗记录站点
        clearExpiredRecord();
        setIsOpen2(true);
        closeWinFor10SecondHandle();
    };

    useEffect(() => {
        initTipsWinFor24();
    }, []);

    useEffect(() => {
        const deviceType = getDevice();
        if (deviceType !== 'desktop' && deviceType !== 'desktop-max') {
            return;
        }
        const checkDailyFirstVisit = async () => {
            if (!isSpecifySite) return;
            try {
                const deviceId = await getEfDeviceId();
                if (!deviceId) return;

                // 生成页面唯一标识
                const pageKey = `${locale}${pathname}`;

                // 检查是否为今日首次访问
                const isFirstVisit = checkIsFirstVisitToday(deviceId, pageKey);

                if (isFirstVisit) {
                    // 记录今日访问
                    recordTodayVisit(deviceId, pageKey);
                    // 自己单独记录，不与open2逻辑交叉，显示弹窗
                    setIsOpen1(true);

                    // 10秒后自动关闭
                    setTimeout(() => {
                        setIsOpen1(false);
                    }, 3 * 1000);
                }
            } catch (error) {
                console.error('检查每日首次访问失败:', error);
            }
        };
        checkDailyFirstVisit();
    }, [isSpecifySite, locale, pathname]);

    return (
        <div className={compCls} onMouseEnter={openCallback} onMouseLeave={closeCallback1}>
            <button className="HeaderV2-r-UserNone-link GtmModuleData-btn-common" onClick={enterUserHandle} aria-label={'user'} data-btn-id="user">
                <HeaderIconUser />
            </button>
            <HeaderUserTipsPc closeCallback={closeCallback2} />
        </div>
    );
}
